exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "ul li[data-v-a9bc89ba]{list-style-type:none;margin:0.7rem 0}ul[data-v-a9bc89ba]{margin:0}\n", ""]);

